import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { connect } from "react-redux";
import { osVersion, osName, isMobile } from 'react-device-detect';
import Dashboard from '../components/Menu/Dashboard';
import { addBeneficiary, getBeneficiaries, getBeneficiaryCore, getBeneficiaryCoreAccount, deleteBeneficiary, updateBeneficiary } from "./../actions/beneficiary";
import { transferRequest } from "./../actions/transfers";
import { getBalanceUser } from "./../actions/balances";
import { createCodeRecovery } from "./../actions/codes";
import { getInstitutionCore } from "./../actions/institutionsCore";
import { internalTransferRequest, externalTransferRequest, internalTransferAthorizedRequest, externalTransferAthorizedRequest } from "./../actions/transferscore";
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import Transfers from '../components/Transfers/Transfers';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import BeneficiaryList from '../components/Complements/BeneficiaryList';
import TransferForm from '../components/Transfers/TransferForm';
import Voucher from '../components/Transfers/Voucher';
import DialogOTP from '../components/Complements/DialogOTP';
// import { history } from './../helpers/history';
import BeneficiaryFormDialog from '../components/Complements/DefaultUserForm';
import { codeActivity, changeStatusUser } from './../actions/codes'
//import client from '../services/feathers';
//import { isMobile, osName, osVersion } from 'react-device-detect';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import { List, ListItem, ListItemAvatar, Avatar, ListItemText, Grid, Button, DialogContentText, CircularProgress } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
//import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import { history } from '../helpers/history';
import BeneficiaryInternalForm from '../components/Complements/BeneficiaryInternalForm';
import BeneficiaryExternalForm from '../components/Complements/BeneficiaryExternalForm';
import StandardDialog from '../components/Complements/StandardDialog';
import LoadingScreen from '../components/Complements/LoadingScreen';
//import { setCodesOTP } from '../functions/core-actions';
import { urlVoucher } from '../services/urls';
import AddIcon from '@material-ui/icons/Add';
import MessageInfo from '../components/Complements/MessageInfo';
import { sendLogs } from '../functions/function-logs';
import { validateIp } from '../functions/store';
import { encrypt, sendMobile, decrypt } from '../functions/mobile';
import { feathersCreateData } from '../services';
import { checkPermissionUser } from '../functions/permissions-functions';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';
//import { th } from 'date-fns/locale';

class TransfersContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialogBeneficiaryList: false,
            openBeneficiaryForm: false,
            beneficiaries: [],
            beneficiariesInternalFilter : [],
            beneficiariesExternalFilter : [],
            inputFilterBeneficiariesInternal : "",
            inputFilterBeneficiariesExternal : "",
            beneficiarySelected: {},
            dataPayment: {
                cedule: '',
                name: '',
                email: '',
                entity: '',
                number: ''
            },
            beneficiaryFormData: {
                number: '',
                cedule: '',
                name: '',
                email: '',
                entity: '',
                document: 'Cédula',
                institution: '',
                beneficiary: 'INTERNO',
                type: '',
                Customers: {},
                accounts: []
            },
            beneficiaryFormDataExternal: {
                number: '',
                cedule: '',
                name: '',
                email: '',
                entity: '',
                document: '1',
                institution: '',
                beneficiary: 'INTERNO',
                type: {},
                Customers: {},
                accounts: []
            },
            transfersData: {},
            beneficiaryDataSend: {},
            openDialogOTP: false,
            QRPay: '',
            codeType: 0,
            initialTime: Date.now(),
            process: 'TRANSFERS',
            otp: '',
            numberAccount: {},
            otpId: '',
            accounts: [],
            accountSelected: {},
            institutions: [],
            internalBeneficiary: {
                open: false,
                data: {}
            },
            externalBeneficiary: {
                open: false,
                data: {}
            },
            confirmDialog: {
                open: false,
                title: ''
            },
            loadingOTP: false,
            loading: false,
            isviewvoucher: false,
            responseservertransfer : {},
            numberdocumento : '',
            contAttemptsInternalTransfer : 0,
            contAttemptsExternalTransfer : 0,
            contAttemptsCreateBeneficiary : 0,
            contAttemptsCreateExternalBeneficiary : 0,
            contAttemptsDeleteBeneficiary : 0,
            opendialoglistaccount : false,
            sendTransaction: false,
            // Se agrega ese campo para identificar si las transacciones van a realizarse bajo autorizadores, cambiar a false si requiere el proceso definido por dycoCore
            AuthorizedTransactions: true
        };
        // this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        // console.log('didmount transfers', this.props.auth)
        this.setState({
            AuthorizedTransactions: Boolean(this.props.auth.companies.authorizeTransactions)
        })
        this.filterAccounts(true)
        this.props.getBeneficiaries(this.props.auth.vusk).then(r => {
             //console.log('los beneficiarios ', r.payload)
            if (r.payload) {
                if (r.payload.length > 0) {
                    this.setState({beneficiaries: r.payload, beneficiariesInternalFilter : r.payload.filter( (item) => item.beneficiary === "INTERNO"), beneficiariesExternalFilter : r.payload.filter( (item) => item.beneficiary === "EXTERNO")})
                } else {
                    this.props.handleOpenSnack('No existen Beneficiarios.', 'info')
                }
            }
        })
        //const transfersCoreService = client.service('transfers-core');
/*         transfersCoreService.on('created', transfer => {
            // console.log(transfer)
            const { cedule } = transfer
            const { NumeroCliente, Identificacion } = this.props.user
            if (cedule === Identificacion) {
                 // console.log('nueva transferencia', transfer)
                this.props.getBalanceUser({NumeroCliente, SecuencialEmpresa: 1}).then( res => {
                    this.filterAccounts(false)
                })
                .catch(err=> {
                    //console.log(' error al obtener balances ', err)
                })
            }
        }
        ); */
        // carga balances
        const { NumeroCliente } = this.props.user
        this.props.getBalanceUser({NumeroCliente, SecuencialEmpresa: 1}).then( res => {
            this.filterAccounts(false)
        })
        .catch(err=> {
            //console.log(' error al obtener balances ', err)
        })
    }

    handleChangeInputOtp = (valueinput) => {
        if(valueinput.toString().length === 4){
            this.handleOTPSubmit({data : valueinput.toString()});
        }

    }

    handleAccountChange = () => {
        const { opendialoglistaccount } = this.state;

        this.setState({
            opendialoglistaccount : !opendialoglistaccount
        })
    }
    // funciones
    getAccountTypeName = (cod) => {
        const { TiposCuenta } = this.props.entities
        const accName = TiposCuenta.find( acc => {
            if (acc.Codigo === cod) {
                return true
            } else {
                return false
            }
        })
        if (accName !== undefined) {
            return accName.Nombre
        } else {
            return 'Nro. Cuenta'
        }
    }

    handleChangeStatusUser = () => {
        this.setState({
            loading : true
        })

        this.props.changeStatusUser({emited : "NAVCHANGESTATUS", iduser : this.props.auth.id}).then(
            response => {
                this.setState({
                    loading : false
                })
            }
        ).catch(
            error => {
                this.setState({
                    loading : false
                })
            }
        )
    }

    handleValidateAttemptsOtp = (cont, typeproccess) => {

        const { parameters, auth, devices, getDeviceData } = this.props

        // console.log("Parametros: ", parameters)getDeviceData = {getDeviceData}

        let contAttemptsAllowed = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'OTP_TRY')[0].value : 5

        cont++;

        switch (typeproccess) {
            case 'INTERNAL_TRANSFER' || 'AUTHORIZED_INTERNAL_TRANSFER':
                sendLogs(auth.vusk, {   NumeroCuentaOrigen: this.state.accountSelected.Codigo,
                                        NumeroCuentaDestino: this.state.beneficiarySelected.number,
                                        Valor: this.state.transfersData.amount,
                                        Detalle: this.state.transfersData.concept,
                                        MontoDiario:10000,
                                        montoMensual:40000,
                                        otpId : this.state.otpId,
                                        email: this.state.transfersData.email
                                    }, 9, devices, getDeviceData)
                this.setState({contAttemptsInternalTransfer : cont})
                break;
            case 'EXTERNAL_TRANSFER' || 'AUTHORIZED_EXTERNAL_TRANSFER':
                sendLogs(auth.vusk, {
                                        NumeroCuentaOrigen: this.state.accountSelected.Codigo,
                                        Valor: this.state.transfersData.amount,
                                        TipoIdentificacion: this.state.beneficiarySelected.document,
                                        Identificacion: this.state.beneficiarySelected.cedule,
                                        NombreApellido: this.state.beneficiarySelected.name,
                                        CodigoTipoInstitucion: this.state.beneficiarySelected.entity,
                                        CodigoTipoCuenta: this.state.beneficiarySelected.type,
                                        NumeroCuentaDestino: this.state.beneficiarySelected.number,
                                        SecuencialInstitucion: this.state.beneficiarySelected.institution,
                                        Detalle: this.state.transfersData.concept,
                                        MontoDiario:10000,
                                        montoMensual:40000,
                                        otpId : this.state.otpId,
                                        email: this.state.transfersData.email
                                    }, 18, devices, getDeviceData)
                this.setState({contAttemptsExternalTransfer : cont})
                break;
            case 'CREATE_BENEFICIARY':
                sendLogs(auth.vusk, {
                    type : "CREATE BENEFICIARY INTERNAL",
                    data : this.state.beneficiaryDataSend
                }, 14, devices, getDeviceData)
                this.setState({contAttemptsCreateBeneficiary : cont})
                break;
            case 'CREATE_EXTERNAL_BENEFICIARY':
                sendLogs(auth.vusk, {
                    type : "CREATE BENEFICIARY EXTERNAL",
                    data : this.state.beneficiaryDataSend
                }, 14, devices, getDeviceData)
                this.setState({contAttemptsCreateExternalBeneficiary : cont})
                break;
            case 'DELETE_BENEFICIARY':
                this.setState({contAttemptsDeleteBeneficiary : cont})
                break;
            default:
                break;
        }

        if(cont > contAttemptsAllowed){
            this.setState({ openDialogOTP: false });
            this.handleChangeStatusUser()
            this.props.handleOpenSnack('Se ha excedido el número de intentos permitidos. Por favor contáctese con COOPERATIVA CAJA llamando al 0958882285.', 'error');
        }

    }

    filterAccounts = (did) => {
        const { balances } = this.props
        const { accountSelected } = this.state
        // console.log('balances en trasfercontainer ', balances)
        const filterBalance = balances.filter( data => {

            if(data.Tipo === 'AHORRO' || 'CUENTA PREMIUM') {
                return true
            } else {
                return false
            }
        })
        if (filterBalance.length > 0) {
            if (did) {
                this.setState({ accounts: filterBalance , accountSelected: filterBalance[0]})
            } else {
                let as = filterBalance.find(val => {
                    if (val.Codigo === accountSelected.Codigo) {
                        return true
                    } else {
                        return false
                    }
                })
                // console.log('actualizamos el saldo a ', as)
                this.setState({ accounts: filterBalance, accountSelected: as })
            }

        }
        // console.log('filtrado ', filterBalance, balances)
    }
    clearForm = () => {
        this.setState(
            {
                beneficiaryFormData: {
                    number: '',
                    cedule: '',
                    name: '',
                    email: '',
                    entity: '',
                    document: 'Cédula',
                    institution: '',
                    beneficiary: 'INTERNO',
                    type: '',
                    Customers: {},
                    accounts: []
                }
            }
        )
    }
    onAcceptClick = async(values) => {

        try {

            this.setState({
                loading : true
            })
            const { auth, devices } = this.props
            const { beneficiaryFormDataExternal, beneficiaries } =this.state

            const dataResult = beneficiaries.filter((beneficiary) => {

                if ((beneficiary.number === values.number) && (beneficiary.beneficiary === "EXTERNO")) {
                    return true
                } else {
                    return false
                }
            })
            // console.log('dataSend', beneficiaryFormDataExternal)

            if(dataResult.length === 0){

                this.setState({
                    beneficiaryDataSend: {
                                            owner:auth.vusk,
                                            type: beneficiaryFormDataExternal.type.Codigo,
                                            type_name: beneficiaryFormDataExternal.type.Nombre,
                                            entity: beneficiaryFormDataExternal.entity.Codigo,
                                            institution: values.institution.Secuencial,
                                            document: values.document,
                                            cedule: values.cedule,
                                            name: values.name.toUpperCase(),
                                            number: values.number,
                                            email: values.email.toLowerCase(),
                                            beneficiary: 'EXTERNO',
                                            name_institution: values.institution.Nombre
                                        },
                process : "ADD_BENEFICIARY"
            })

                const { ip, device, mac } = devices

                let sendData = encrypt(JSON.stringify({
                    emited: 'NAVCREATECODE',
                    type : 14,
                    deviceData: device,
                    ip,
                    mac
                } ))

                await feathersCreateData('codes-recovery', { sendData })()

                this.setState({
                    initialTime: Date.now(),
                    openDialogOTP: true,
                    loading : false
                })
                // crear directamente
/*                 if (sendTransaction === false) {
                    this.setState({sendTransaction: true})
                    this.setState({loading:true})
                    this.props.addBeneficiary({
                        owner:auth.vusk,
                        type: beneficiaryFormDataExternal.type.Codigo,
                        type_name: beneficiaryFormDataExternal.type.Nombre,
                        name: values.name.toUpperCase(),
                        number: values.number,
                        email: values.email,
                        entity: beneficiaryFormDataExternal.entity.Codigo,
                        beneficiary: 'EXTERNO',
                        cedule: values.cedule,
                        document: values.document,
                        institution: values.institution.Secuencial
                    }).then(r => {
                        // console.log( 'mi respuesta al crear', r.payload)
                        if (r.payload) {
                            let newbeneficiaries = beneficiaries;
                            newbeneficiaries.push({
                                owner:auth.vusk,
                                type: beneficiaryFormDataExternal.type.Codigo,
                                type_name: beneficiaryFormDataExternal.type.Nombre,
                                name: values.name.toUpperCase(),
                                number: values.number,
                                email: values.email,
                                entity: beneficiaryFormDataExternal.entity.Codigo,
                                beneficiary: 'EXTERNO',
                                cedule: values.cedule,
                                document: values.document,
                                institution: values.institution.Secuencial
                            })
                            this.props.handleOpenSnack('Se ha agregado correctamente el beneficiario.', 'success')
                            this.setState({openBeneficiaryForm: false})
                            this.clearForm()
                            this.setState({loading:false, beneficiaries : newbeneficiaries})
                            this.setState({sendTransaction: false})
                            this.handleCloseDialogOTP()
                        }
                    }).catch( err => {
                        this.setState({loading:false})
                        this.setState({sendTransaction: false})
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack('El beneficiario no pudo ser agregado. Por favor intente nuevamente.', 'error')
                    })
                } */
            }else{
                this.setState( {loading: false })
                this.props.handleOpenSnack('El beneficiario ya existe. Por favor verifique los datos.', 'info');
            }

            ///=======
            /* this.props.createCodeRecovery({ type: 14, emited: 'NAV', user: auth.vusk, change: 'usuario', deviceData: `${osName} ${osVersion}` }).then( res => {
                const { result, data } = res.payload
                // console.log(result, data)
                this.setState( {initialTime: Date.now() })
                this.setState({ openDialogOTP: true, otp: result, email: auth.mail, seq: data.sequence, process: 'CREATE_EXTERNAL_BENEFICIARY' })
            }).catch( error => {
                console.log('error en el proceso ', error)
                this.props.handleOpenSnack('No se a podido realizar la accion, intente nuevamente ', 'error')
            }) */
        } catch (error) {
            this.setState( {loading: false })
            this.props.handleOpenSnack('Ha ocurrido un error. Por favor vuelva a intentar.', 'info');
        }


        // this.props.addBeneficiary()
    }
    handleGetSelectAccount = (value) => {
        this.setState({numberAccount: value})
    }
    handleAddBeneficiaryCore = async() => {

        try {

            this.setState({loading : true})

            const { auth, devices } = this.props
            const { beneficiaryFormData, numberAccount, beneficiaries } =this.state
            //console.log('anadiendoooo', numberAccount)
            const { name, email, cedule} = beneficiaryFormData

            const dataResult = beneficiaries.filter((beneficiary) => {

                if ((beneficiary.number === numberAccount.Codigo) && (beneficiary.beneficiary === "INTERNO")) {
                    return true
                } else {
                    return false
                }
            })

            if(dataResult.length === 0){

                this.setState({
                    beneficiaryDataSend: {
                        owner:auth.vusk,
                        type: 'AHORROS',
                        type_name: numberAccount.TipoCuenta,
                        entity:'LOCAL',
                        institution: 'COOPERATIVA CAJA',
                        document: 'Cédula',
                        cedule,
                        name,
                        number: numberAccount.Codigo,
                        email,
                        beneficiary: 'INTERNO',
                        name_institution: "COOPERATIVA CAJA"
                    },
                    process : "ADD_BENEFICIARY"
                })

                const { ip, device, mac } = devices

                let sendData = encrypt(JSON.stringify({
                    emited: 'NAVCREATECODE',
                    type : 14,
                    deviceData: device,
                    ip,
                    mac
                } ))

                await feathersCreateData('codes-recovery', { sendData })()

                this.setState({
                    initialTime: Date.now(),
                    openDialogOTP: true,
                    loading : false
                })

            }else{

                this.setState({loading : false})
                this.props.handleOpenSnack('El beneficiario ya se encuentra agregado.', 'info')
            }


        } catch (error) {

            this.setState({loading : false})
            this.props.handleOpenSnack('Ha ocurrido un error al generar el código', 'error')
        }
        // console.log('dataSend core', beneficiaryDataSend)
        // agregado directo
        /* this.props.addBeneficiary({
            owner:auth.vusk,
            type: 'AHORROS',
            type_name: numberAccount.TipoCuenta,
            name,
            number: numberAccount.Codigo,
            email,
            beneficiary: 'INTERNO',
            cedule,
            entity:'LOCAL',
            institution: 'COOPERATIVA CAJA',
            document: 'Cédula'
        }).then(r => {
            // console.log( 'mi respuesta al crear', r.payload)
            if (r.payload) {
                this.props.handleOpenSnack('Beneficiario agregado', 'success')
                this.setState({openBeneficiaryForm: false})
                this.clearForm()
                this.setState({loading:false})
                this.handleCloseDialogOTP()
            }
        }).catch( err => {
            this.setState({loading:false})
            this.handleCloseDialogOTP()
            this.props.handleOpenSnack('El beneficiario no pudo ser agregado. Por favor intente nuevamente.', 'error')
        }) */

    }

    // handle
    handleOpenBeneficiaryList = () => {
        this.props.getBeneficiaries(this.props.auth.vusk).then(r => {
            // console.log('los beneficiarios ', r.payload)
            if (r.payload) {
                this.setState({beneficiaries: r.payload, openDialogBeneficiaryList: true, beneficiariesInternalFilter : r.payload.filter( (item) => item.beneficiary === "INTERNO"), beneficiariesExternalFilter : r.payload.filter( (item) => item.beneficiary === "EXTERNO")})
            }
        })

        // console.log('la verdad lista ', this.state.openDialogBeneficiaryList)
    }
    handleGetBeneficiarySelected = (beneficiarySelected) => {
        // se obtiene el nombre del tipo de cuenta
        //console.log("Cuenta seleccionada: ", this.state.accountSelected)
        //console.log("Beneficiario seleccionado: ", beneficiarySelected)

        if(this.state.accountSelected.Codigo !== beneficiarySelected.number){

            let BS = beneficiarySelected
            if ((beneficiarySelected.beneficiary === 'EXTERNO')) {
                // console.log('el beneficiario ', beneficiarySelected)
                let complete = true
                for (const key in beneficiarySelected) {
                    if (beneficiarySelected[key] === "") {
                        if (key === 'document') {
                            beneficiarySelected[key] = '1'
                        }
                        complete = false
                    }
                }
                if (complete) {
                    // verifica que esten todos los datos
                    // console.log('porque entra aqui')
                    const  accname = this.getAccountTypeName(beneficiarySelected.type)
                    BS.accname = accname
                } else {
                    this.props.handleOpenSnack('Debe completar la información del beneficiario.', 'info')
                    this.handleChangeEntity({Codigo: beneficiarySelected.entity})
                    this.setState({externalBeneficiary:{...this.state.externalBeneficiary, open: true, data: beneficiarySelected}})
                }
            } else {
                BS.accname = beneficiarySelected.type
            }

            this.setState({beneficiarySelected: BS , openDialogBeneficiaryList: false})
        }else{
            this.props.handleOpenSnack('No se permite seleccionar un número de cuenta idéntico al número de cuenta origen. Por favor seleccione otro beneficiario.', 'info')
        }
      // console.log('se a seleccionado ', beneficiarySelected)
    };
    handleCloseBeneficiaryList = () => {
      this.setState({ openDialogBeneficiaryList: false });
    };
    handleSubmit = (values) => {
        try {

            const { parameters } = this.props;

            const resultFilterValueMinBalance = parameters.filter( (param) => param.name === "MINIMUM_BALANCE")
            const valueMinBalance = (resultFilterValueMinBalance.length > 0) ? resultFilterValueMinBalance[0].value : "2"
            //console.log(resultFilterValueMinBalance)
            const {daily, monthly, mAmount, dAmount, updateQuota  } = this.props.quotas[0]
            let sameDay = moment(moment(new Date(updateQuota)).format('YYYY-MM-DD')).isSame(moment(new Date()).format('YYYY-MM-DD'))
            let sameMonth =  moment(moment(new Date(updateQuota)).format('YYYY-MM-DD')).isSame(moment(new Date()).format('YYYY-MM-DD'),'month')
            //console.log('', sameDay,  sameMonth,
            //(parseFloat(dAmount) + parseFloat(values.amount)), parseFloat(daily), (parseFloat(dAmount) + parseFloat(values.amount)) >=  parseFloat(daily))
            // si la fecha esta actualizada
            // if(state) {
                //console.log(this.props.quotas, parseFloat(values.amount) , parseFloat(daily) , parseFloat(values.amount) >= parseFloat(daily) , parseFloat(values.amount)>= parseFloat(monthly))
                if ( parseFloat(values.amount) > this.state.accountSelected.SaldoCuenta) {
                    this.props.handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
                } else if(  (parseFloat(dAmount) >= parseFloat(daily) ||
                            (parseFloat(dAmount) + parseFloat(values.amount)) >  parseFloat(daily)) && sameDay
                            ) {
                    this.props.handleOpenSnack('El monto excede el límite de transferencia diaria', 'error')
                }else if(  (parseFloat(mAmount) >= parseFloat(monthly) ||
                            (parseFloat(mAmount) + parseFloat(values.amount)) >  parseFloat(monthly)) && sameMonth
                            ) {
                    this.props.handleOpenSnack('El monto excede el límite de transferencia mensual', 'error')
                } else if(parseFloat(values.amount) > parseFloat(daily) ) {
                    this.props.handleOpenSnack('El valor excede el monto diario permitido', 'error')
                } else if(parseFloat(values.amount)> parseFloat(monthly)) {
                    this.props.handleOpenSnack('El valor excede el monto mensual permitido', 'error')
                } else if((parseFloat(this.state.accountSelected.SaldoCuenta) - parseFloat(values.amount)) < parseFloat(valueMinBalance)){
                    this.props.handleOpenSnack('El valor del saldo mínimo no debe ser menor a $ '+valueMinBalance, 'error')
                }else{
                    this.handleProcessTransfer(values)
                }
            /* } else {
                console.log('sin validacion')
                this.handleProcessTransfer(values)
            } */

        } catch (error) {
            this.setState({loading: false})
            //console.log('error al crear otp ', error)
        }

    }

    handleProcessTransfer = async (values) => {
        try {
            this.setState({loading: true})
            await this.props.getQuotas({cedule: this.props.auth.vusk})
            const {getDeviceData, updateIpDevice, devices } = this.props
            const { ip } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            if (!isEmpty(this.props.devices)) {
                const { device, ip: ipdevice, mac } = this.props.devices
                values.device = `${device}`;
                values.ip = ipdevice;
                values.mac = mac;
            } else {
                values.ip = ipSend;
                values.device = `${osName} ${osVersion}`;
                values.mac = 'NAVEGADOR';
            }
            values.concept = values.concept.toUpperCase()
            const { beneficiarySelected } = this.state


            let sendData = encrypt(JSON.stringify({
                values,
                beneficiarySelected,
                NumeroCuentaOrigen: encrypt(this.state.accountSelected.Codigo),
                type : (beneficiarySelected.beneficiary === 'INTERNO') ? 9 : 18
            } ))

            this.props.transferRequest({sendData}).then( r => {
                //console.log('mi respuesta es ', r.payload)

                const { responseData } = r.payload

                const responseDataDecrypt = JSON.parse(decrypt(responseData))

                if(responseDataDecrypt.type === "success"){

                    this.setState({
                        initialTime: Date.now(),
                        codeType: 0,
                        openDialogOTP: true,
                        //QRPay: r.payload.data.qr,
                        process: this.state.AuthorizedTransactions ? (beneficiarySelected.beneficiary === 'INTERNO') ? 'AUTHORIZED_INTERNAL_TRANSFER' : 'AUTHORIZED_EXTERNAL_TRANSFER':
                        (beneficiarySelected.beneficiary === 'INTERNO') ? 'INTERNAL_TRANSFER' : 'EXTERNAL_TRANSFER',
                        //otpId: r.payload.data.id,
                        //otp: r.payload.data.otp,
                        transfersData: values
                    })

                }else{

                    this.props.handleOpenSnack(responseDataDecrypt.alert, responseDataDecrypt.type)

                }

                this.setState({loading: false})
            }).catch(err => {
                //console.log(err)
                this.setState({loading: false})
                this.props.handleOpenSnack('Ha ocurrido un error. Por favor vuelva a intentar.', 'error')
            })
        } catch (error) {
            //console.log(error)
        }
    }

    handleAceptDialog = (values) => {
        try {
            this.handleCloseBeneficiaryList()
            const { id } = values.data
                    this.props.deleteBeneficiary(id).then(res => {
                        this.props.handleOpenSnack('Se ha eliminado el beneficiario correctamente.', 'success')
                        this.setState({confirmDialog: { open: false, title: ''}})
                        this.setState({externalBeneficiary: {
                            ...this.state.externalBeneficiary,
                            open: false
                        }})
                        this.handleCloseDialogOTP()
                        this.setState({openBeneficiaryForm: false, })
                        this.clearForm()
                        this.setState({loading:false})
                    }).catch(err => {
                        this.setState({loading:false})
                        this.handleCloseDialogOTP()
                        //console.log('error al eliminar beneficiario ', err)
                    })
            /* let sendData = {
                event: 2,
                type: 19,
                beneficiarySelected: values.data
            }

            this.props.transferRequest(sendData).then( r => {
                // console.log('transferRequest delete ', r.payload)
                if (r.payload) {
                    this.setState({confirmDialog: { open: false, title: ''}})
                    this.setState({externalBeneficiary: { open: false, data: {}}})
                    this.setState({
                        initialTime: Date.now(),
                        codeType: 0,
                        openDialogOTP: true,
                        QRPay: r.payload.data.qr,
                        process:  'DELETE_BENEFICIARY',
                        otpId: r.payload.data.id,
                        otp: r.payload.data.otp,
                        transfersData: values
                    })
                }
            }).catch(err => {
                console.log(err)
                this.props.handleOpenSnack('Error', 'error')
            }) */
        } catch (error) {
            //console.log(error)
        }
    }

    handleUpdatedBalances = async() => {
        await this.props.getBalanceUser({NumeroCliente: this.props.user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true}).then( res => {

            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.Secuencial === this.state.accountSelected.Secuencial) ? true : false;

            })

            this.setState({
                accountSelected : getdataaccountselected[0]
            })

        })
        .catch(err=> {
            //console.log(' error al obtener balances ', err)
        })
    }

    handleOTPSubmit = async(values) => {

        try {

            const { beneficiarySelected,
                    process,
                    transfersData,
                    accountSelected,
                    sendTransaction,
                    beneficiaryDataSend
            } = this.state
            const { concept, amount } = transfersData
            const { number, cedule, name, entity, type, document, institution, id } = beneficiarySelected
            const { devices } = this.props
            //console.log(devices)
            const { ip, mac, device } = devices

            this.setState({loading:true})

            let typeCodeOtp = 9;

            switch (process) {
                
                case "INTERNAL_TRANSFER" :
                case 'AUTHORIZED_INTERNAL_TRANSFER' :
                    typeCodeOtp = 9
                    break;
                case "EXTERNAL_TRANSFER" :
                case 'AUTHORIZED_EXTERNAL_TRANSFER':
                    typeCodeOtp = 18
                    break;
                case "ADD_BENEFICIARY":
                    typeCodeOtp = 14
                    break;
                case "REMOVE_BENEFICIARY":
                    typeCodeOtp = 19
                    break;
                case "UPDATE_BENEFICIARY":
                    typeCodeOtp = 31
                    break;
                default:
                    break;
            }

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type : typeCodeOtp,
                inputOtp : values.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type : typeMessage, viewDialogOtp } = responseValidateCode;

            if(error === false){

                if (process === 'INTERNAL_TRANSFER') {
                    // console.log('ingresa a comparar ', otp.toString(), values.data, transfersData)
                    //if (otp.toString() === values.data) {
                        // setCodesOTP(otpId, 'v', 'transfers' ).then(res => {})
                        // console.log('enviando ', sendTransaction)
                        if (sendTransaction === false) {
                            this.setState({sendTransaction: true})
                            //let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                            //this.setState({loading:true})
                            //accountSelected.Codigo
                            const sendData = encrypt(JSON.stringify({
                                NumeroCuentaOrigen: accountSelected.Codigo,
                                NumeroCuentaDestino: number,
                                Valor: amount,
                                Detalle: concept,
                                emailBeneficiario: transfersData.email.toLowerCase(),
                                dataDevice : {
                                    ip,
                                    mac,
                                    device
                                },
                                otp : values.data
                            }))
                            this.props.internalTransferRequest({
                                sendData
                            }).then(res => {
                                const {error} = res.payload
                                let response = res.payload.data
                                this.setState({sendTransaction: false})
                                if (error) {
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    this.handleCloseDialogOTP()
                                    this.setState({loading:false})
                                } else {
                                    this.handleUpdatedBalances()
                                    // console.log('respuesta del server ', res.payload)
                                    this.handleCloseDialogOTP()
                                    this.setState({
                                        loading:false, 
                                        isviewvoucher: true, 
                                        responseservertransfer : response, 
                                        numberdocumento : response.Documento
                                    })
                                        // this.resetviewtransfert()
                                    //this.handleCancelTransferForm()
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    //history.push('/')
                                }
                            }).catch( err => {
                                this.setState({sendTransaction: false})
                                this.setState({loading:false})
                                this.handleCloseDialogOTP()
                                // this.props.handleOpenSnack('Error al realizar transacción. Por favor intente nuevamente.', 'error')
                                this.props.handleOpenSnack(err.message, 'error')

                            })
                        }


                } else if (process === 'EXTERNAL_TRANSFER') {
                    // console.log('ingresa a comparar ', otp.toString(), values.data, beneficiarySelected)
                    //if (otp.toString() === values.data) {
                        //console.log('enviando ', sendTransaction)
                        //setCodesOTP(otpId, 'v' ).then(res => {})
                        if (sendTransaction === false) {
                            this.setState({sendTransaction: true})
                            //let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)

                            const sendData = encrypt(JSON.stringify({
                                NumeroCuentaOrigen: accountSelected.Codigo,
                                Valor: amount,
                                TipoIdentificacion: document,
                                Identificacion: cedule,
                                NombreApellido: name,
                                CodigoTipoInstitucion: entity,
                                CodigoTipoCuenta: type,
                                NumeroCuentaDestino: id,
                                SecuencialInstitucion: institution,
                                Detalle: concept,
                                emailBeneficiario: transfersData.email.toLowerCase(),
                                dataDevice : {
                                    ip,
                                    mac,
                                    device
                                },
                                otp : values.data
                            }))
                            this.props.externalTransferRequest({
                                sendData
                            }).then(res => {
                                // console.log('respuesta del server ', res)
                                this.setState({sendTransaction: false})
                                const {error} = res.payload
                                let response = res.payload.data
                                if (error) {
                                    //console.log('errror de transaccion')
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    this.setState({sendTransaction: false})
                                    this.setState({loading:false})
                                } else {
                                    this.handleUpdatedBalances()
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    this.setState({loading:false, 
                                        isviewvoucher:true, 
                                        responseservertransfer : response, numberdocumento : response.documento})
                                        // this.resetviewtransfert()
                                }

                                this.handleCloseDialogOTP()
                            }).catch( err => {
                                this.setState({sendTransaction: false})
                                this.setState({loading:false})
                                this.handleCloseDialogOTP()
                                //console.log('error en transferecnia', err)
                                // this.props.handleOpenSnack('Error al realizar transacción. Por favor intente nuevamente.', 'error')
                            })
                        }

                } else if (process === "ADD_BENEFICIARY"){

                    this.setState({loading:true})

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action : "ADD_BENEFICIARY",
                        dataUsersDefault : beneficiaryDataSend,
                        dataDevice : {
                            ip,
                            mac,
                            device,
                        },
                        type : 14,
                        otp : values.data
                    }))

                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData  : sendDataAddBeneficiary})()

                    if(responseCreateBeneficiary.error === false){
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({openBeneficiaryForm: false, loading:false})
                        this.clearForm()
                        this.handleCloseDialogOTP()
                    }else{
                        this.setState({loading:false})
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else if (process === "REMOVE_BENEFICIARY"){

                    this.setState({loading:true})

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action : "REMOVE_BENEFICIARY",
                        dataUsersDefault : beneficiaryDataSend,
                        dataDevice : {
                            ip,
                            mac,
                            device,
                        },
                        type : 19,
                        otp : values.data
                    }))

                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData  : sendDataAddBeneficiary})()

                    if(responseCreateBeneficiary.error === false){
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({loading:false})
                        this.handleCloseBeneficiaryList()
                        this.handleCloseDialogOTP()
                    }else{
                        this.setState({loading:false})
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else if (process === "UPDATE_BENEFICIARY"){

                    this.setState({loading:true})

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action : "UPDATE_BENEFICIARY",
                        dataUsersDefault : beneficiaryDataSend,
                        dataDevice : {
                            ip,
                            mac,
                            device,
                        },
                        type : 31,
                        otp : values.data
                    }))

                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData  : sendDataAddBeneficiary})()

                    if(responseCreateBeneficiary.error === false){
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({loading:false, externalBeneficiary: {
                            open: false,
                            data: {}
                        }, internalBeneficiary : {
                            open: false,
                            data: {}
                        }})
                        this.handleCloseBeneficiaryList()
                        this.handleCloseDialogOTP()
                    }else{
                        this.setState({loading:false})
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else if (process === 'AUTHORIZED_INTERNAL_TRANSFER') {
                    
                        if (sendTransaction === false) {
                            this.setState({sendTransaction: true})                           
                            const sendData = encrypt(JSON.stringify({
                                NumeroCuentaOrigen: accountSelected.Codigo,
                                NumeroCuentaDestino: number,
                                Valor: amount,
                                Detalle: concept,
                                emailBeneficiario: transfersData.email.toLowerCase(),
                                dataDevice : {
                                    ip,
                                    mac,
                                    device
                                },
                                otp : values.data,
                                service : 'CREATE_TRANSFERS',
                                TipoIdentificacion: document,
                                Identificacion: cedule,
                                NombreApellido: name,

                            }))
                            this.props.internalTransferAthorizedRequest({
                                sendData
                            }).then(res => {
                                const {error} = res.payload
                                let response = res.payload.data
                                this.setState({sendTransaction: false})
                                if (error) {
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    this.handleCloseDialogOTP()
                                    this.setState({loading:false})
                                } else {
                                    this.handleUpdatedBalances()
                                    this.handleCloseDialogOTP()
                                    this.setState({loading:false,
                                        //  isviewvoucher:true, 
                                         responseservertransfer : response, numberdocumento : response.Documento})
                                         this.resetviewtransfert()
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                }
                            }).catch( err => {
                                this.setState({sendTransaction: false})
                                this.setState({loading:false})
                                this.handleCloseDialogOTP()
                                this.props.handleOpenSnack(err.message, 'error')
                            })
                        }


                } else if (process === 'AUTHORIZED_EXTERNAL_TRANSFER') {
                    
                        if (sendTransaction === false) {
                            this.setState({sendTransaction: true})

                            const sendData = encrypt(JSON.stringify({
                                NumeroCuentaOrigen: accountSelected.Codigo,
                                Valor: amount,
                                TipoIdentificacion: document,
                                Identificacion: cedule,
                                NombreApellido: name,
                                CodigoTipoInstitucion: entity,
                                CodigoTipoCuenta: type,
                                NumeroCuentaDestino: id,
                                SecuencialInstitucion: institution,
                                Detalle: concept,
                                emailBeneficiario: transfersData.email.toLowerCase(),
                                dataDevice : {
                                    ip,
                                    mac,
                                    device
                                },
                                otp : values.data,
                                service : 'CREATE_TRANSFERS',

                            }))
                            this.props.externalTransferAthorizedRequest({
                                sendData
                            }).then(res => {
                                this.setState({sendTransaction: false})
                                const {error} = res.payload
                                let response = res.payload.data
                                if (error) {
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    this.setState({sendTransaction: false})
                                    this.setState({loading:false})
                                } else {
                                    this.handleUpdatedBalances()
                                    this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                    this.setState({loading:false,
                                        //  isviewvoucher:true,
                                          responseservertransfer : response, numberdocumento : response.documento})
                                          this.resetviewtransfert()
                                }

                                this.handleCloseDialogOTP()
                            }).catch( err => {
                                this.setState({sendTransaction: false})
                                this.setState({loading:false})
                                this.handleCloseDialogOTP()
                            })
                        }

                }

            }else{
                if(viewDialogOtp === false){
                    this.handleCloseDialogOTP()
                }
                this.props.handleOpenSnack(message, typeMessage)
                this.setState({loading:false})
            }

        } catch (error) {
            this.setState({loading:false})
            this.props.handleOpenSnack('Ha ocurrido un error al realizar la operación.', 'error')
        }

    }
    handleCloseDialogOTP = () => {
        this.setState({ openDialogOTP: false });
    };
    handleCancelTransferForm = () => {
        this.setState({beneficiarySelected: {}})
        history.push('/')
    }
    handleOpenBeneficiaryForm = () => {
        this.setState({ openBeneficiaryForm: true })
    }
    handleonCloseBeneficiaryForm = () => {
        this.setState({ openBeneficiaryForm: false, beneficiaryFormData: {
            number: '',
            cedule: '',
            name: '',
            email: '',
            entity: '',
            type: '',
            Customers: {},
            accounts: []
        } })
    }
    handleGetAccount = (id, field) => {
        const { beneficiaries } = this.props
        //console.log('buscando ....', id, field)
        this.clearForm()
        if (field === 'account') {
            const getBeneficiaryInStore = beneficiaries.find(beneficiary => beneficiary.number === id)
            if (getBeneficiaryInStore === undefined) {
                this.props.getBeneficiaryCoreAccount(id).then(r => {
                    //console.log('encuentra esto ', r.payload)
                    if(r.payload.message){
                        this.props.handleOpenSnack(r.payload.message, r.payload.type)
                    } else {
                        const {NumeroCliente, NombreCliente, CorreoElectronico, CodigoCuenta, Cuentas } = r.payload.data
                        const accountsFind = Cuentas.filter(acc => acc.TipoCuenta !== 'CERTIFICADOS DE APORTACION')
                        if (accountsFind.length > 0 ) {
                            //console.log("Cuentas Filtradas ", accountsFind)
                            this.setState({beneficiaryFormData: {
                                number: CodigoCuenta, name: NombreCliente, email: CorreoElectronico, cedule: NumeroCliente,
                                accounts: Cuentas
                            } })
                        } else {
                            //console.log("No se ha encontrado el numero de cuenta.")
                            this.props.handleOpenSnack('No se ha encontrado el numero de cuenta.', 'info')
                        }
                    }
                    // this.setState({beneficiaryFormData: r.payload })
                }).catch(error => {
                    //console.log('el error ', error)
                    this.props.handleOpenSnack('La cuenta no existe.', 'error')
                })
            } else {
                this.props.handleOpenSnack('El beneficiario ya se encuentra agregado.', 'info')
                // const { number, name, email, cedule } = getBeneficiaryInStore
                this.handleCloseDialogOTP()
            }
        } else {
            this.props.getBeneficiaryCore({cedule: id, SecuencialEmpresa: 1}).then(r => {
                //console.log('encuentra esto ', r.payload)
                if(r.payload.data.Cuentas.length === 0){
                    this.props.handleOpenSnack("El usuario no tiene cuentas disponibles.", "info");
                } else {
                    const { NumeroCliente, Nombres, Apellidos, CorreoElectronico, Cuentas, Identificacion } = r.payload.data
                    this.setState({beneficiaryFormData: {
                        number: NumeroCliente, name: `${Nombres} ${Apellidos}`, email: CorreoElectronico, cedule: Identificacion,
                        accounts: Cuentas
                    } })
                }
                // this.setState({beneficiaryFormData: r.payload })
            }).catch(error => {
                //console.log('el error ', error)
                this.props.handleOpenSnack('El usuario no existe.', 'error')
            })
        }


    }
    handleAccountSelect = (value) => {
        // console.log('cambio ', value)
        this.setState({accountSelected: value})
    }
    handleChangeEntity = (entity) => {
        try {
            const { institutions, getInstitutionCore } = this.props

            const findInstitutionsInStore = institutions.find( ins => {
                if (ins.code === entity.Codigo) {
                    return true
                } else {
                    return false
                }
            })
            if (findInstitutionsInStore !== undefined)  {
                this.setState({ institutions: findInstitutionsInStore.InformacionInstituciones})
            } else {
                getInstitutionCore({CodigoTipoInstitucion: entity.Codigo}).then( res => {
                    /* console.log("Consultando: ", res)
                    console.log("Codigo: ", entity.Codigo) */
                    const {error, data} = res.payload
                    if (error){
                        this.props.handleOpenSnack(res.payload.message, res.payload.type)
                    } else {
                        if(entity.Codigo === "CPE"){
                            //console.log("CONSULTA COOPERATIVAS ", entity.Codigo)
                            const filterIntitutions = data.InformacionInstituciones.filter(item => item.Nombre !== "COOPERATIVA CAJA.");
                            this.setState({ institutions: filterIntitutions})
                        }else{
                            //console.log("CONSULTA OTROS ", entity.Codigo)
                            this.setState({ institutions: data.InformacionInstituciones})
                        }
                    }

                })
            }
            this.setState(prevState => ({
                beneficiaryFormDataExternal: {
                    ...prevState.beneficiaryFormDataExternal,
                    entity
                }
            }))
        } catch (error) {
            //console.log(error)
        }

    }
    handleUpdateBeneficiary = async(beneficiary) => {

        try {

            //console.log(beneficiary)

            this.setState({loading : true})

            const { institutions } = this.state

            //console.log(institutions)

            const responseFilterInstitution = institutions.filter( (row) => row.Secuencial.toString() === beneficiary.institution.toString())

            //console.log(responseFilterInstitution)

            const { ip, device, mac } = this.props.devices

            let sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE',
                type : 31,
                deviceData: device,
                ip,
                mac
            } ))

            await feathersCreateData('codes-recovery', { sendData })()

            this.setState({
                initialTime: Date.now(),
                openDialogOTP: true,
                loading : false,
                beneficiaryDataSend: {
                    ...beneficiary,
                    name_institution : (responseFilterInstitution.length > 0) ? responseFilterInstitution[0].Nombre : "COOPERATIVA CAJA"
                },
                process : "UPDATE_BENEFICIARY"
            })

        } catch (error) {

            this.props.handleOpenSnack('Ha ocurrido un error al generar el otp.', 'error')
            this.setState({loading : true})

        }

    }
    // renders
    renderBeneficiaryForm = () => {
        const {entities} = this.props
        const { institutions } = this.state
        return  <BeneficiaryFormDialog
                    {...this.state}
                    //beneficiaries = {this.state.beneficiaries}
                    //handleOpenSnack = {this.props.handleOpenSnack}
                    userPermissions ={this.props.userPermissions}
                    clearForm = {this.clearForm}
                    findAccountUser = { this.handleGetAccount }
                    accounts = { this.state.beneficiaryFormData.accounts }
                    institutions = { institutions }
                    entities = { entities }
                    // email = {"asda@asd.com"}
                    setEntity = { this.handleChangeEntity }
                    setInstitution = {
                        institution => this.setState({
                            ...this.state,
                            beneficiaryFormDataExternal: {
                                ...this.state.beneficiaryFormDataExternal,
                                institution
                            }
                        })
                    }
                    setDocument = {
                        document => this.setState(prevState => ({
                            beneficiaryFormDataExternal: {
                                ...prevState.beneficiaryFormDataExternal,
                                document
                            }
                        }))
                    }
                    setType = { type => this.setState({
                        ...this.state,
                        beneficiaryFormDataExternal: {
                            ...this.state.beneficiaryFormDataExternal,
                            type
                        }
                    })}
                    onAcceptClick = { this.onAcceptClick }
                    AddBeneficiaryCore = { this.handleAddBeneficiaryCore }
                    getSelectAccount = { this.handleGetSelectAccount}
                    onCloseBeneficiaryForm ={this.handleonCloseBeneficiaryForm}/>
    }
    renderTransferForm = () => {
        const { loading, beneficiarySelected } = this.state
        // console.log('beneficiario seleccionado ', beneficiarySelected)
        if (loading ) {
            return <CircularProgress />
        } else {
            return <TransferForm
                    amount = {""}
                    email = {beneficiarySelected.email}
                    onSubmit = { this.handleSubmit }
                    dataForm = { {} }
                    cancelButton = { this.handleCancelTransferForm }/>
        }
    }

    responseDataFilterBeneficiariesInternal = () => {

        const { beneficiaries, inputFilterBeneficiariesInternal } = this.state

        //console.log(beneficiaries)

        const responseFilterBeneficiaries = beneficiaries.filter((item) => item.name.toUpperCase().includes(inputFilterBeneficiariesInternal.toUpperCase()) || item.number.toUpperCase().includes(inputFilterBeneficiariesInternal.toUpperCase()) || item.cedule.toUpperCase().includes(inputFilterBeneficiariesInternal.toUpperCase()))

        //console.log(responseFilterBeneficiaries)

        const responseBeneficiaries = responseFilterBeneficiaries.filter( (item) => item.beneficiary === "INTERNO")

        this.setState({
            beneficiariesInternalFilter : responseBeneficiaries
        })
    }

    responseDataFilterBeneficiariesExternal = () => {

        const { beneficiaries, inputFilterBeneficiariesExternal } = this.state

        //console.log(beneficiaries)

        const responseFilterBeneficiaries = beneficiaries.filter((item) => item.name.toUpperCase().includes(inputFilterBeneficiariesExternal.toUpperCase()) || item.number.toUpperCase().includes(inputFilterBeneficiariesExternal.toUpperCase()) || item.cedule.toUpperCase().includes(inputFilterBeneficiariesExternal.toUpperCase()))

        //console.log(responseFilterBeneficiaries)

        const responseBeneficiaries = responseFilterBeneficiaries.filter( (item) => item.beneficiary === "EXTERNO")

        this.setState({
            beneficiariesExternalFilter : responseBeneficiaries
        })

    }

    handleChangeInputFilterBeneficiariesInternal = (input) => {
        //console.log(input.target.value)
        this.setState({inputFilterBeneficiariesInternal : input.target.value})
    }

    handleChangeInputFilterBeneficiariesExternal = (input) => {
        //console.log(input.target.value)
        this.setState({inputFilterBeneficiariesExternal : input.target.value})
    }

    renderBeneficiaryList = () => {
        return <BeneficiaryList
                    {...this.state}
                    handleSubmitBeneficiariesInternal = { this.responseDataFilterBeneficiariesInternal }
                    handleSubmitBeneficiariesExternal = { this.responseDataFilterBeneficiariesExternal }
                    handleChangeInputFilterBeneficiariesInternal = { this.handleChangeInputFilterBeneficiariesInternal }
                    handleChangeInputFilterBeneficiariesExternal = { this.handleChangeInputFilterBeneficiariesExternal }
                    openDialogBeneficiaryForm = { () => {
                        this.handleCloseBeneficiaryList()
                        this.handleOpenBeneficiaryForm()
                    }
                    }
                    userPermissions ={this.props.userPermissions}
                    getBeneficiarySelected = { this.handleGetBeneficiarySelected }
                    onCloseDialogBeneficiaryList = {this.handleCloseBeneficiaryList}
                    editBeneficiary = { (select) => {
                            //console.log(select)
                            const { beneficiary } = select
                            // console.log(beneficiary)
                            if (beneficiary === 'INTERNO')
                                this.setState({internalBeneficiary:{...this.state.internalBeneficiary, open: true, data: select}})
                            else {
                                this.handleChangeEntity({Codigo: select.entity})
                                this.setState({externalBeneficiary:{...this.state.externalBeneficiary, open: true, data: select}})
                            }


                        }
                    }
                    deleteBeneficiary = { async (select) => {
                            //console.log(select)
                            //const { beneficiary } = select
                            //if (beneficiary === 'INTERNO') {

                            try {

                                this.setState({loading : true})

                                const { ip, device, mac } = this.props.devices

                                let sendData = encrypt(JSON.stringify({
                                    emited: 'NAVCREATECODE',
                                    type : 19,
                                    deviceData: device,
                                    ip,
                                    mac
                                } ))

                                await feathersCreateData('codes-recovery', { sendData })()

                                this.setState({
                                    initialTime: Date.now(),
                                    openDialogOTP: true,
                                    loading : false,
                                    beneficiaryDataSend: select,
                                    process : "REMOVE_BENEFICIARY"
                                })

                            } catch (error) {

                                this.props.handleOpenSnack('Ha ocurrido un error al generar el otp.', 'error')
                                this.setState({loading : true})
                            }

                        }
                    }
                    handleConvertMask = { this.handleConvertMask }
                    />
    }
    renderDialogConfirm = () => {
        const { internalBeneficiary, confirmDialog } = this.state
        return <StandardDialog
                    open = { confirmDialog.open}
                    title = { confirmDialog.title }
                    handleClose = { () => this.setState({ confirmDialog: { open: false, title: ''}}) }
                >
                    <DialogContentText id="alert-dialog-description">
                        {<b>{`¿Desea eliminar el beneficiario ${internalBeneficiary.data.name} ?`}</b>}
                    </DialogContentText>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={6}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick = { () => this.handleAceptDialog(internalBeneficiary)}
                            >
                                Eliminar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" onClick = { () => this.setState({ confirmDialog: { open: false, title: ''}})}>Cancelar</Button>
                        </Grid>
                    </Grid>
                </StandardDialog>
    }

    resetviewtransfert = () => {
        // console.log("regresa");
        this.setState({
            isviewvoucher : false,
            beneficiarySelected : {}
        })
    }

    handleSendEmailWithVoucher = () => {

        this.setState({loading:true})

        const { CorreoElectronico } = this.props.user;

        // console.log("Correo Electronico: ", CorreoElectronico);

        const { numberdocumento } = this.state;

        //const { Monto, NumeroCuentaOrigen } = responseservertransfer;

        let object_send_email_with_voucher = {
            Documento : "voucher_"+numberdocumento,
            Email : CorreoElectronico
        }

        this.props.sendEmailWithVoucher(object_send_email_with_voucher).then(
            response => {

                const { message, type } = response.payload;

                this.setState({loading:false})

                this.props.handleOpenSnack(message, type);
            }
        ).catch(
            error => {
                this.setState({loading:false})
                this.props.handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
            }
        )
    }

    handleDownloadVoucher = () => {
        const { numberdocumento, accountSelected, responseservertransfer } = this.state;
        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: numberdocumento, name_voucher: responseservertransfer.name_voucher})().then(res => {
            if (res.error) {
                this.props.handleOpenSnack(res.message, 'error')
            } else {

                // window.open(urlVoucher+res.voucher+".pdf", '_blank');
                if (isMobile) {
                    handleDownloadMovil(urlVoucher, res.voucher)
                } else {
                    handleDownloadWeb(urlVoucher, res.voucher)
                }

            }
        }).catch(err => this.props.handleOpenSnack('No se ha encontrado el documento', 'error') )
    }

    onKeyPress = (ev) => {
        //console.log(ev.target.value)
        if (ev.key === 'Enter') {
            ev.preventDefault()
        } else {
            if(ev.target.value.toString().length === 4){
                // console.log("VALUE OTP: ", valueinput)
                this.handleOTPSubmit({data: ev.target.value});
            }

        }
    }

    handleConvertMask = (numberBeneficiary) => {

        if(numberBeneficiary.length > 8){

            let resultConvert = ""

            const [ a, b, c, d, ...dataConvert ] = numberBeneficiary

            for(let y=0; y < dataConvert.length; y++){

                if(y < (dataConvert.length - 4)){
                    resultConvert = resultConvert.concat("X")
                }else{
                    resultConvert = resultConvert.concat(dataConvert[y])
                }
            }

            resultConvert = a+b+c+d+resultConvert

            return resultConvert

        }else{

            return numberBeneficiary

        }

    }

    renderOTPRequest = () => {
        return <DialogOTP
                    {...this.state}
                    showQR = {false}
                    onCloseDialogOTP = { this.handleCloseDialogOTP }
                    onKeyPress = { this.onKeyPress }
                    handleChangeInputOtp = { this.handleChangeInputOtp }
                    OTPSubmit = { this.handleOTPSubmit }
                />
    }


    renderBody = () => {
        const {entities} = this.props
        const { accounts, accountSelected, beneficiarySelected, institutions, isviewvoucher, AuthorizedTransactions, responseservertransfer, numberdocumento } = this.state
        const { Monto, NumeroCuentaDestino, Fecha, Email } = responseservertransfer;

        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para realizar transferencias'} />
            } else {
                return  <div>
                        {
                            (accounts.length > 0) &&
                            <UserPanelInfoMobile
                                user = {this.props.user}
                                balances = {this.props.balances}
                                accountSelected = { accountSelected }
                                changeAccount = { this.handleAccountSelect}
                                handleAccountChange = { this.handleAccountChange }
                                dialog = { this.state.opendialoglistaccount}
                            >
                                    {
                                        (isviewvoucher === true && AuthorizedTransactions  === false) ?
                                        <Voucher
                                            amount = { Monto }
                                            titleheader = { "Valor transferido" }
                                            title = { "Transferencia exitosa!" }
                                            databodyone = {
                                                [
                                                    {
                                                        title : "Desde cuenta de:",
                                                        value : this.props.user.Nombres + " " +this.props.user.Apellidos,
                                                        order : 1
                                                    },
                                                    {
                                                        title : "Cuenta de destino:",
                                                        value : NumeroCuentaDestino,
                                                        order : 2
                                                    },
                                                    {
                                                        title : "No. transferencia:",
                                                        value : numberdocumento,
                                                        order : 3
                                                    },
                                                    {
                                                        title : "Fecha:",
                                                        value : moment(Fecha).format("YYYY/MM/DD"),
                                                        order : 4
                                                    },
                                                    {
                                                        title : "Email",
                                                        value : (Email) ? Email : "",
                                                        order : 5
                                                    },
                                                ]
                                            }
                                            //onActionAfter = { this.resetviewtransfert }
                                            //handleCancelTransferForm = { this.handleCancelTransferForm }
                                            handleCancel = { this.resetviewtransfert }
                                            textButtonCancel = {"Nueva Transferencia"}
                                            handleDownloadVoucher = { this.handleDownloadVoucher}
                                            handleDownloadDevice = { () => {
                                                try {
                                                    feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: numberdocumento, name_voucher: responseservertransfer.name_voucher})().then(res => {
                                                        if (res.error) {
                                                            this.props.handleOpenSnack(res.message, 'error')
                                                        } else {
                                                            const namefile = res.name_voucher
                                                            let send = {
                                                                type: 'action',
                                                                action: 'export_voucher',
                                                                data: urlVoucher+namefile+".pdf",
                                                                nameFile: namefile,
                                                                extension: 'pdf',
                                                                messageSend: 'Transferencia'
                                                            }
                                                            sendMobile(JSON.stringify(send))
                                                        }
                                                    }).catch(err => this.props.handleOpenSnack('No se ha encontrado el documento', 'error') )

                                                } catch (error) {
                                                    //console.log(error)

                                                }
                                            }}
                                        />
                                        :
                                        beneficiarySelected.owner  ?
                                            <div>
                                                <List style = {{flexGrow: 1}}>
                                                    <ListItem button  >
                                                        <ListItemAvatar>
                                                        <Avatar aria-label="recipe" style= {{backgroundColor: 'rgb(0, 160, 175)'}} >
                                                            <AccountCircleIcon />
                                                        </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={
                                                                <span style = {{color: 'rgb(0, 0, 1)', fontWeight: 'bold', fontSize: '0.79rem'}}>
                                                                    { `${beneficiarySelected.name} `}
                                                                </span>
                                                            }
                                                            secondary={
                                                                <span style = {{color: 'rgb(0, 0, 1)', fontSize: '0.875rem'}}>
                                                                    { `${beneficiarySelected.accname} - ${(beneficiarySelected.type_name === "TARJETA DE CREDITO") ? this.handleConvertMask(beneficiarySelected.number) : beneficiarySelected.number}` }
                                                                </span>
                                                            } />
                                                    </ListItem>
                                                </List>
                                                {
                                                    this.renderTransferForm()
                                                }
                                            </div>
                                        :

                                        <List style = {{flexGrow: 1}}>
                                            {/* <ListItem button  onClick={ () => this.handleAccountChange() }>
                                                <ListItemAvatar>
                                                <Avatar aria-label="recipe" >
                                                    <AccountBalanceWalletIcon />
                                                </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Cambiar Cuenta" secondary="" />
                                            </ListItem> */}
                                            <ListItem button  onClick={ () => this.handleOpenBeneficiaryList() }>
                                                <ListItemAvatar>
                                                <Avatar aria-label="recipe" >
                                                    <AccountCircleIcon />
                                                </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Seleccione Beneficiario" secondary="" />
                                            </ListItem>
                                            <ListItem button  onClick={ () => this.handleOpenBeneficiaryForm() }>
                                                <ListItemAvatar>
                                                <Avatar aria-label="recipe" >
                                                    <AddIcon />
                                                </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Agregar Nuevo Beneficiario" secondary="" />
                                            </ListItem>
                                        </List>
                                    }
                                    { this.renderBeneficiaryList() }
                                    { this.renderBeneficiaryForm()}
                                    { this.renderOTPRequest() }
                                    {checkPermissionUser(this.props.userPermissions, 1) &&
                                        <BeneficiaryInternalForm
                                        internalBeneficiary = { this.state.internalBeneficiary }
                                        onCloseBeneficiaryForm = {() =>  this.setState({internalBeneficiary: {
                                            ...this.state.internalBeneficiary,
                                            open: false
                                        }})}
                                        onAcceptClick = { (data) => { this.handleUpdateBeneficiary(data) }}
                                    />}
                                    {checkPermissionUser(this.props.userPermissions, 2) &&
                                    <BeneficiaryExternalForm
                                        externalBeneficiary = { this.state.externalBeneficiary }
                                        beneficiaries = {this.state.beneficiaries}
                                        handleOpenSnack = {this.props.handleOpenSnack}
                                        onCloseBeneficiaryForm = {() =>  {
                                            //console.log('cierra ventana')
                                            this.setState({beneficiarySelected: {}})
                                            this.setState({externalBeneficiary: {
                                            ...this.state.externalBeneficiary,
                                            open: false

                                            }})}
                                        }
                                        institutions = {institutions}
                                        changeEntity = {(Codigo) => this.handleChangeEntity({Codigo})}
                                        setDocument = {(document) => {
                                            //console.log("Nuevo tipo de documento ",document)
                                            let newobject = {
                                                data : {...this.state.externalBeneficiary.data, document},
                                                open : true
                                            }
                                            //console.log("Nuevo tipo de documento ",newobject)
                                            this.setState({
                                                externalBeneficiary : newobject
                                            })
                                        }}
                                        document = {this.state.externalBeneficiary.data.document}
                                        entities = { entities }
                                        onAcceptClick = { this.handleUpdateBeneficiary}
                                        onDeleteClick = { (internalBeneficiary) => {
                                            this.setState({internalBeneficiary: {...this.state.internalBeneficiary, data: internalBeneficiary}})
                                            this.setState({ confirmDialog: { open: true, title: 'Eliminar Beneficiario'}})
                                        }}


                                    />}

                                    { this.renderDialogConfirm()}

                            </UserPanelInfoMobile>
                        }
                    </div>
            }


        } else {
            /*balances = {accounts.filter(acc => {
                                    if (acc.Tipo === 'DEPOSITOS A LA VISTA')
                                        return true
                                    else
                                        return false
                                })} */
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para realizar transferencias'} />
            } else {
                return  <div>
                    {
                        (accounts.length > 0) &&
                        <Transfers
                                { ...this.state }
                                user = {this.props.user}
                                balances = {this.props.balances}
                                openBeneficiaryList = { this.handleOpenBeneficiaryList }
                                openDialogBeneficiaryForm = { this.handleOpenBeneficiaryForm }
                                transferForm = { this.renderTransferForm() }
                                dialogOTP = { this.renderOTPRequest() }
                                changeAccount = { this.handleAccountSelect}
                                accountSelected = { accountSelected}
                                handleSendEmailWithVoucher = {this.handleSendEmailWithVoucher}
                                handleCancelTransferForm = { this.handleCancelTransferForm }
                                onActionAfter = { this.resetviewtransfert }
                                handleDownloadVoucher = { this.handleDownloadVoucher }
                                handleDownloadDevice = { () => {
                                    try {
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: numberdocumento, name_voucher: responseservertransfer.name_voucher})().then(res => {
                                            if (res.error) {
                                                this.props.handleOpenSnack(res.message, 'error')
                                            } else {
                                                const namefile = res.voucher
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher+namefile+".pdf",
                                                    nameFile: namefile,
                                                    extension: 'pdf',
                                                    messageSend: 'Transferencia'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            }
                                        }).catch(err => this.props.handleOpenSnack('No se ha encontrado el documento', 'error') )

                                    } catch (error) {
                                        //console.log(error)

                                    }
                                }}
                                handleConvertMask = { this.handleConvertMask }
                        />
                    }
                    { this.renderBeneficiaryList() }
                    { this.renderBeneficiaryForm()}
                    {checkPermissionUser(this.props.userPermissions, 1) &&
                    <BeneficiaryInternalForm
                        internalBeneficiary = { this.state.internalBeneficiary }
                        onCloseBeneficiaryForm = {() =>  this.setState({internalBeneficiary: {
                            ...this.state.internalBeneficiary,
                            open: false
                        }})}
                        onAcceptClick = { (data) => { this.handleUpdateBeneficiary(data) }}
                    />}
                    {checkPermissionUser(this.props.userPermissions, 2) &&
                    <BeneficiaryExternalForm
                        externalBeneficiary = { this.state.externalBeneficiary }
                        beneficiaries = {this.state.beneficiaries}
                        handleOpenSnack = {this.props.handleOpenSnack}
                        onCloseBeneficiaryForm = {() =>  {
                            //console.log('cierra ventana')
                            this.setState({beneficiarySelected: {}})
                            this.setState({externalBeneficiary: {
                            ...this.state.externalBeneficiary,
                            open: false

                            }})}
                        }
                        setDocument = {(document) => {
                            //console.log("Nuevo tipo de documento ",document)
                            let newobject = {
                                data : {...this.state.externalBeneficiary.data, document},
                                open : true
                            }
                            //console.log("Nuevo tipo de documento ",newobject)
                            this.setState({
                                externalBeneficiary : newobject
                            })
                        }}
                        document = {this.state.externalBeneficiary.data.document}
                        entities = { entities }
                        institutions = {institutions}
                        changeEntity = {(Codigo) => this.handleChangeEntity({Codigo})}
                        onAcceptClick = { this.handleUpdateBeneficiary }
                        onDeleteClick = { (internalBeneficiary) => {
                            this.setState({internalBeneficiary: {...this.state.internalBeneficiary, data: internalBeneficiary}})
                            this.setState({ confirmDialog: { open: true, title: 'Eliminar Beneficiario'}})
                        }}

                    />}
                    { this.renderDialogConfirm()}
                </div>
            }

        }

    }
    render() {
        const {loading} = this.state
        return (
            <div>
                <Dashboard
                    title= ""
                    body = { this.renderBody() }
                    multiple = { false }
                />
                <LoadingScreen open={loading} />
            </div>
        );
    }
}

TransfersContainer.propTypes = {
    user: PropTypes.object,
    entities: PropTypes.object.isRequired,
};

export default withRouter(connect(null, {
        addBeneficiary,
        getBeneficiaries,
        transferRequest,
        getBeneficiaryCore,
        createCodeRecovery,
        getBeneficiaryCoreAccount,
        internalTransferRequest,
        externalTransferRequest,
        codeActivity,
        getBalanceUser,
        getInstitutionCore,
        deleteBeneficiary,
        updateBeneficiary,
        sendEmailWithVoucher,
        changeStatusUser,
        internalTransferAthorizedRequest,
        externalTransferAthorizedRequest
    } )(TransfersContainer))
